const createInputFilePreview = () => {
  const inputs = $('input[type="file"]');
  inputs.each((index, input) => {
    $(input).on('change', (e) => {
      const label = $(input).prev().find('span');
      const fileName = e.target.value.split('\\').pop();

      if (fileName) {
        label.html(fileName);
      }
    });
  });
};

export default createInputFilePreview;



// WEBPACK FOOTER //
// /app/app/assets/javascripts/packs/auth/createInputFilePreview.js